<template>
  <div id="app">
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
    </head>
    <!-- <div id="in-progress">
      <img src="./assets/logo.svg" alt="" srcset="">
      <div class="message">
        Sitio en construcción.
      </div>
    </div> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  beforeCreate() {
    this.$store.commit('fetchFiles')
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital@0;1&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Vesper+Libre:wght@400;900&display=swap');

:root {
  --black: #262626;
  --vesper: 'Vesper Libre', serif;
  --courier: 'Courier Prime', monospace;
  --white: #fffbf8;
}

body {
  margin: 0;
  padding: 0;
  height: 100vh;
  background-color: var(--white);
}

#app {
  height: 100%;
  color: #262626;
  background-color: var(--white);
}

#in-progress {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.message {
  font-family: var(--courier);
  font-size: 34px;
}
</style>
